import Master from "@/layout/components/Master.vue";

export const master=[
    {
        path: 'master/admin',
        component: Master,
        children: [
            {
                path: 'list',
                component: () => import('@/views/master/admin/Admin.vue')
            },
            {
                path: 'school',
                component: () => import('@/views/master/admin/AdminAccount.vue')
            },
            {
                path: 'update-permissions',
                component: () => import('@/views/supper-system/UpdatePermissions.vue')
            },
        ]
    },
    {
        path: 'master/agent',
        component: Master,
        children: [
            {
                path: 'list',
                component: () => import('@/views/master/agent/Agent.vue')
            },
            {
                path: 'account',
                component: () => import('@/views/master/agent/AccountAgent.vue')
            },
            {
                path: 'add',
                component: () => import('@/views/master/agent/CreateAgent.vue')
            }
        ]
    },
    {
        path: 'master/school-agent',
        component: Master,
        children: [
            {
                path: 'list',
                component: () => import('@/views/master/school/School.vue')
            },
            {
                path: 'account-school',
                component: () => import('@/views/master/school/AccountSchool.vue')
            },
            {
                path: 'student-in-school',
                component: () => import('@/views/master/school/StudentInSchool.vue')
            },
            {
                path: 'employee-in-school',
                component: () => import('@/views/master/school/EmployeeInSchool.vue')
            },
        ]
    },
    {
        path: 'master/notify',
        component: Master,
        children: [
            {
                path: 'news-onekids',
                component: () => import('@/views/master/notify/News.vue')
            },
            {
                path: 'notify-onekids',
                component: () => import('@/views/master/notify/AppSendNotify.vue')
            },
            {
                path: 'history-sms',
                component: () => import('@/views/master/notify/HistorySms.vue')
            },
            {
                path: 'feedback-onekids',
                component: () => import('@/views/master/notify/FeedBackOnekids.vue')
            }
        ]
    },
    // {
    //   path: 'notification',
    //   component: Master,
    //   children: [
    //     {
    //       path: 'notify',
    //       component: () => import('@/views/master/notification/ViewContentNotification.vue')
    //     },
    //     {
    //       path: 'internal-notification',
    //       component: () => import('@/views/master/notification/AppSendNotification.vue')
    //     }
    //   ]
    // },
    {
        path: 'master/user',
        component: Master,
        children: [
            {
                path: 'account',
                component: () => import('@/views/master/account/AccountManage.vue')
            },
        ]
    },
    {
        path: 'master/system-config',
        component: Master,
        children: [
            {
                path: 'attendance-sample',
                component: () => import('@/views/master/systemconfig/AttendanceSampleConfig.vue')
            },
            {
                path: 'evaluate-sample',
                component: () => import('@/views/master/systemconfig/EvaluateSampleConfig.vue')
            },
            {
                path: 'web-system-title',
                component: () => import('@/views/master/systemconfig/WebSystemTitleConfig.vue')
            },
            {
                path: 'system-setting',
                component: () => import('@/views/master/systemconfig/SystemSettingConfig.vue')
            },
            {
                path: 'school',
                component: () => import('@/views/master/systemconfig/SchoolSystemConfig.vue')
            },
            {
                path: 'api',
                component: () => import('@/views/master/systemconfig/ApiData.vue')
            },
            {
                path: 'support',
                component: () => import('@/views/master/systemconfig/Support.vue')
            },
            {
                path: 'orther',
                component: () => import('@/views/master/systemconfig/BirthdaySampleConfig.vue')
            },
            {
                path: 'template',
                component: () => import('@/views/master/systemconfig/TemplateConfig.vue')
            },
            {
                path: 'survey-form',
                component: () => import('@/views/master/systemconfig/SurveyForm/SurveyFormSystem.vue')
            },
            {
                path: 'ticket',
                component: () => import('@/views/master/systemconfig/TicketConfig.vue')
            },
            {
                path: "devices-face-recognition",
                component: () => import('@/views/master/identify/ManagerDevices.vue')
            },
            {
                path: "card-manager-recognition",
                component: () => import('@/views/master/identify/CardManager.vue')
            },
            {
                path: "check-info-recognition",
                component: () => import('@/views/master/identify/CheckRecognition.vue')
            },
            {
                path: "bank-connection",
                component: () => import('@/views/sepay/BanksConnectedSePay.vue')
            },
            {
                path: "brand-name-connection",
                component: () => import('@/views/sepay/BrandConnectedSePayVersion2.vue')
            },
            {
                path: "linked-school-bank-account",
                component: () => import('@/views/sepay/LinkedSchoolBankAccount.vue')
            },
            {
                path: "student-user-statistics-admin",
                component: () => import('@/views/sepay/StudentUserStatisticsAdmin.vue')
            },
            {
                path: "bank-transaction-statistics",
                component: () => import('@/views/sepay/BankTransactionStatistics.vue')
            },
            {
                path: "transaction-volume-chart",
                component: () => import('@/views/sepay/TransactionVolumeChart.vue')
            },
            {
                path: "transaction-counter-admin",
                component: () => import('@/views/sepay/TransactionCounterAdmin.vue')
            },
            {
                path: "merchant/online-payment",
                component: () => import('@/views/sepay/MerchantManagement.vue')
            },
            {
                path: "webhook/online-payment",
                component: () => import('@/views/sepay/WebhookManagement.vue')
            },
            {
                path: "emotion-chat-admin",
                component: () => import('@/views/master/systemconfig/chat/emotion/EmotionChatSystem.vue')
            },
            {
                path: "tag-chat-admin",
                component: () => import("@/views/master/systemconfig/chat/tag/TagChatSystem.vue")
            }

        ]
    },
    {
        path: 'master/other',
        component: Master,
        children: [
            {
                path: 'create-data-system',
                component: () => import('@/views/master/other/CreateDataSystem.vue')
            },
            {
                path: 'manage-request-system',
                component: () => import('@/views/master/other/ShowNumberOfRequest.vue')
            },
            {
                path: 'manage-data-system',
                component: () => import('@/views/master/other/ManageDataSystem.vue')
            },
            {
                path: 'manage-operation-history',
                component: () => import('@/views/master/other/ManageOperationHistoryS3.vue')
            },
            {
                path: 'auto-run-configuration',
                component: () => import('@/views/master/other/AutoRunConfiguration.vue')
            },
            {
                path: 'receive-messages-system',
                component: () => import('@/views/master/other/ReceiveMessagesSystem.vue')
            },
            {
                path: 'icon-system',
                component: () => import('@/views/master/data/IconSystem.vue')
            },
            {
                path: 'onekids-config',
                component: () => import('@/views/master/systemconfig/OneKidsConfig.vue')
            },
            {
                path: 'login-config',
                component: () => import('@/views/master/data/LoginConfig.vue')
            },
            {
                path: 'album-sync',
                component: () => import('@/modules/album/AlbumLegacySync.vue')
            },
        ]
    },
]
